module.exports = __webpack_public_path__ + "images/halloween_lp/MV_characters_PC_7da5f553669fb1aea85ba253c24c366c.png";